import { useEffect, useState } from 'react';
import { axiosCaller } from '../../../utils/apiCaller';

export interface ClientOption {
    id: number;
    name: string;
    city: string | null;
}

export interface ResponsibilityOption {
    id: number;
    name: string;
}

export interface FilterOptions {
    clients: ClientOption[];
    cities: string[];
    responsibilities: ResponsibilityOption[];
}

/**
 * One-shot fetch of /analytics/filter-options — populates the picker
 * dropdowns for client, city, responsibility. Cached for an hour by the
 * backend, so re-mounts are cheap.
 */
export function useFilterOptions() {
    const [options, setOptions] = useState<FilterOptions | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        axiosCaller('GET', 'analytics/filter-options')
            .then((res: any) => {
                if (cancelled) return;
                setOptions(res?.data ?? null);
                setLoading(false);
            })
            .catch(() => {
                if (cancelled) return;
                setOptions(null);
                setLoading(false);
            });
        return () => { cancelled = true; };
    }, []);

    return { options, loading };
}
